<div class="modal-header pt-1 mb-1 position-relative">
  <h3 class="mt-0 modal-title text-center mx-auto" id="modal-confirm-title" translate>Before Proceeding...</h3>
  <button class="btn-close btn-red" (click)="reject()"></button>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-center align-items-center mb-2" translate>
    Prior to saving additional data, kindly complete the required fields below to successfully finalize the operation:
    <!-- In order to save your modifies in your profile, you must fill the following fields there are mandatory to complete: -->
  </div>
  <form [formGroup]="formGroup" class="form">
    <div class="form-group" *ngIf="formGroup?.get('field_birth_date')">
      <label for="field_birth_date">
        <span class="text-primary" translate>Birthdate</span>
        <span class="small text-danger"> *</span>
      </label>
      <div
        class="input-group"
        [ngClass]="{
              'not-valid-field': toolsService.fieldIsInvalid(formGroup, 'field_birth_date'),              
              
            }"
      >
        <div class="input-group-text"><i class="icon icon-calendar-alt"></i></div>
        <input
          id="field_birth_date"
          class="form-control px-2 bg-white text-dark pointer"
          formControlName="field_birth_date"
          #d="ngbDatepicker"
          (click)="d.toggle()"
          [minDate]="{ year: now.getFullYear() - 80, month: 01, day: 01 }"
          [maxDate]="{ year: now.getFullYear() - 12, month: 12, day: 31 }"
          placeholder="{{ 'Select Date' | translate }}"
          ngbDatepicker
          readonly
          [ngClass]="{
            'is-invalid': toolsService.fieldIsInvalid(formGroup, 'field_birth_date'),            
          }"
        />
      </div>
      <div
        *ngIf="toolsService.fieldHasError(formGroup, 'field_birth_date', 'required')"
        class="invalid-feedback ms-4"
        translate
      >
        the field is required
      </div>
      <div
        *ngIf="toolsService.fieldHasError(formGroup, 'field_birth_date', 'ngbDate')"
        class="invalid-feedback ms-4"
        translate
      >
        the date is not valid
      </div>
    </div>

    <div class="form-group" *ngIf="formGroup?.get('field_nationality')">
      <label>
        <span class="text-primary" translate>Nationality</span>
        <span class="small text-danger"> *</span>
      </label>
      <country-selector
        formControlName="field_nationality"
        iconPrepend="icon-globe-americas"
        [placeholder]="'Nationality' | translate"
        [showError]="toolsService.fieldIsInvalid(formGroup, 'field_nationality')"
      ></country-selector>
      <div
        *ngIf="toolsService.fieldHasError(formGroup, 'field_nationality', 'required')"
        class="invalid-feedback ms-4"
        translate
      >
        the field is required
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-center mt-4">
    <button class="btn btn-info rounded-1" (click)="reject()" translate>Cancel</button>
    <button class="btn btn-success rounded-1" (click)="confirm()">Confirm</button>
  </div>
</div>
